import { FileModel } from "../data/file";
import { Dimensions, StyleSheet } from "react-native";
import { useTheme } from "react-native-paper";

const useStyles = () => {
  const theme = useTheme();
  const styles = StyleSheet.create({
    map: {
      width: "100%",
      height: "100%",
    },
    calloutContainer: {
      width: 280,
    },
    linkIcon: {
      height: 16,
      width: 16,
      marginLeft: 5,
      marginRight: 5,
    },
    customCallout: {
      backgroundColor: theme.colors.surface,
      borderRadius: 8,
      padding: 0,
      shadowColor: "#000",
      shadowOffset: {
        width: 0,
        height: 4,
      },
      shadowOpacity: 0.3,
      shadowRadius: 5,
      elevation: 8,
      borderWidth: 1,
      borderColor: theme.colors.outlineVariant,
      overflow: "hidden",
      width: 280,
    },
    calloutHeader: {
      backgroundColor: theme.colors.primaryContainer,
      padding: 12,
      borderBottomWidth: 1,
      borderBottomColor: theme.colors.outlineVariant,
    },
    calloutBody: {
      padding: 12,
    },
    calloutTitle: {
      fontSize: 16,
      fontWeight: "700",
      color: theme.colors.onPrimaryContainer,
      marginBottom: 0,
    },
    calloutDescription: {
      fontSize: 13,
      lineHeight: 18,
      color: theme.colors.onSurfaceVariant,
      marginBottom: 0,
    },
    calloutFooter: {
      flexDirection: "row",
      justifyContent: "flex-end",
      gap: 4,
      paddingHorizontal: 8,
      paddingVertical: 8,
      borderTopWidth: 1,
      borderTopColor: theme.colors.outlineVariant,
    },
    calloutButton: {
      padding: 4,
    },
  });
  return styles;
};

const LATITUDE_DELTA = 0.0922;

function calculateRegion(lat: number, lon: number) {
  const { width, height } = Dimensions.get("window");
  const aspect_ratio = width / height;
  const region = {
    lat: lat,
    lng: lon,
    latitudeDelta: LATITUDE_DELTA,
    longitudeDelta: LATITUDE_DELTA * aspect_ratio,
  };
  return region;
}
type MapProps = { lat: number; lon: number; files: Array<FileModel>; onRefresh?: () => void };

export { useStyles, calculateRegion, MapProps };
